module.exports = __webpack_public_path__ + "img/team-list1.d514c2a0.png";